<template>
  <div class="crevent-redeemed-page">
    <div v-if="loading" class="crevent-state">資料載入中...</div>
    <div v-if="!loading" class="RedeemedList">
      <div class="container">
        <div class="redeem_box">
          <div class="title_box"><img src="img/title_icon3.svg" alt=""><h2>兌換明細頁</h2></div>
          <p v-if="eventName" class="crevent-event-name">{{ eventName }}</p>
          <ul class="coupon_list rwd">
            <li class="title"><div><img src="img/basket_icon.svg" alt=""><p>商品資訊</p></div></li>
            <li v-for="item in rows" :key="item.CRRId">
              <div class="coupon_link">
                <div class="img_box"><img :src="itemImage(item.Image)" :alt="item.ItemName + '圖片'"></div>
                <div class="text_box">
                  <h3>{{ item.ItemName }}</h3>
                  <p><span><img src="img/time_icon.svg" alt="">兌換時間：</span><span>{{ timeString(item.RedeemTime) }}</span></p>
                  <p><span><img src="img/leaf_b.svg" alt="">扣除減碳量：</span><span>{{ formatCarbon(item.CarbonAmount) }} kg CO₂e</span></p>
                </div>
              </div>
            </li>
          </ul>
          <ul class="coupon_list web">
            <li class="title">
              <div class="img_title"><img src="img/basket_icon.svg" alt=""><p>商品資訊</p></div>
              <div class="text_box"><img src="img/time_icon_w.svg" alt=""><p>兌換時間</p></div>
              <div class="text_box"><img src="img/leaf_w.svg" alt=""><p>扣除減碳量</p></div>
            </li>
            <li v-for="item in rows" :key="'web-' + item.CRRId">
              <div class="coupon_link">
                <div class="img_title"><div class="img_box"><img :src="itemImage(item.Image)" :alt="item.ItemName + '圖片'"></div><div class="text_box"><h3>{{ item.ItemName }}</h3></div></div>
                <div class="text_box"><p><span>兌換時間：</span><span>{{ timeString(item.RedeemTime) }}</span></p></div>
                <div class="text_box"><p><span>扣除減碳量：</span><span>{{ formatCarbon(item.CarbonAmount) }} kg CO₂e</span></p></div>
              </div>
            </li>
          </ul>
          <p v-if="rows.length === 0" class="crevent-empty">尚無兌換記錄</p>
          <div v-if="pageCount > 1" class="page_bg">
            <paginate :page-count="pageCount" :page-range="2" :margin-pages="2" :prev-text="'<'" :next-text="'>'" :container-class="'page_box'" :page-class="'page'" :prev-class="'prev'" :next-class="'next'" :click-handler="loadList" :value="currentPage"></paginate>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
/* global $, moment */
import Paginate from 'vuejs-paginate'
import Storage from '@/utils/storage.js'

export default {
  name: 'CREventRedeemedList',
  components: { Paginate },
  data () {
    return { loading: true, rows: [], eventName: '', siteUrl: '', currentPage: 1, perPage: 5, total: 0 }
  },
  computed: { pageCount () { return Math.max(1, Math.ceil(this.total / this.perPage)) } },
  mounted () {
    $('.wrapper').addClass('crevent-redeemed-list')
    $(window).scrollTop(0)
    this.loadList(1)
  },
  methods: {
    loadList (page) {
      const that = this
      that.loading = true
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + '/Htmlv2/CREventRedeemedList',
        type: 'post',
        dataType: 'json',
        data: { token: Storage.get('ek_login_token'), CREId: that.$route.params.CREId, page: page, perPage: that.perPage },
        complete: function () { that.loading = false },
        success: function (res) {
          if (!res.ok) return that.handleError(res)
          that.rows = res.rows
          that.eventName = res.EventName
          that.siteUrl = res.SiteUrl
          that.currentPage = res.page
          that.perPage = res.perPage
          that.total = res.total
          $(window).scrollTop(0)
        },
        error: function () { that.showError('取得兌換記錄失敗，請稍後再試一次') }
      })
    },
    itemImage (image) { return image ? this.siteUrl + image : 'img/coupon_logo.svg' },
    timeString (time) { return moment(time).format('YYYY-MM-DD HH:mm') },
    formatCarbon (value) { return Number(value || 0).toFixed(1) },
    handleError (res) {
      if (res && res.toekn_error) {
        Storage.remove('ek_login_token')
        this.$router.push({ name: 'Login' })
        return
      }
      this.showError((res && res.error) || '操作失敗')
    },
    showError (message) { this.$swal({ heightAuto: false, title: '錯誤', text: message, icon: 'error', confirmButtonText: '確定' }) }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CREventRedeemedList.vue